import { DocumentSubjectType } from 'commons/types/enums'
import { ManageDocumentFormType } from '~bank-documents/types/documentEdit'

export const mapManageDocumentRequest = (value: ManageDocumentFormType): ManageDocumentFormType => {
  const newValue = { ...value }

  if (value.frequency === 'one-time') {
    newValue.startDateType = 'account_opening'
  }

  if (value.subjectType === DocumentSubjectType.COMPANY) {
    newValue.licenseId = undefined
    newValue.contactId = undefined
    newValue.bankAccountId = undefined
  }

  if (value.subjectType === DocumentSubjectType.LICENSE) {
    newValue.companyId = undefined
    newValue.contactId = undefined
    newValue.bankAccountId = undefined
  }

  if (value.subjectType === DocumentSubjectType.BANK_ACCOUNT) {
    newValue.companyId = undefined
    newValue.contactId = undefined
    newValue.licenseId = undefined
  }

  if (value.subjectType === DocumentSubjectType.CONTACT) {
    newValue.companyId = undefined
    newValue.bankAccountId = undefined
    newValue.licenseId = undefined
  }

  return newValue
}
